import { FormItem, ISelectOption, Select, SelectMini } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useClients } from '../../core/app/AppContext';
import { Brand } from '../../sections/client-management/entities';
import { entityToSortedSelectOptions } from '../utils/getSelectOptions';

interface IProps {
  isMini: boolean;
}
const Container = styled.div<IProps>`
  ${props => (props.isMini ? '' : 'width: 300px;')}
`;

export function BrandSelect({ brandId, onBrandChanged, isMini = false }) {
  const { getBrands } = useClients();
  const { t } = useTranslation('components');

  const brands: ISelectOption<string>[] = entityToSortedSelectOptions<Brand>(getBrands());

  const handleBrandChange = (option: ISelectOption<string>) => {
    if (option?.value) {
      onBrandChanged(option.value);
    }
  };
  //Find the ISelectOption associated with this brandId
  const brandValue = brands.find(brand => brand.value === brandId);
  const inputId = 'brand-select';

  return (
    <Container isMini={isMini} data-testid="BrandSelectContainer">
      <FormItem
        isMini={isMini}
        spacingBelow={false}
        label={`${t('brandSelect.label')}${isMini ? ':' : ''}`}
        for={inputId}
      >
        {isMini ? (
          <SelectMini
            ariaLabel={t('brandSelect.aria')}
            options={brands}
            isSorted={true}
            searchable={true}
            minLength={2}
            onChange={handleBrandChange}
            value={brandValue}
            placeholder={t('brandSelect.placeholder')}
            // TODO:AMAX needs an inputId prop to allow label targetting
          />
        ) : (
          <Select
            ariaLabel={t('brandSelect.aria')}
            options={brands}
            isSorted={true}
            searchable={true}
            minLength={2}
            onChange={handleBrandChange}
            value={brandValue}
            placeholder={t('brandSelect.placeholder')}
            inputId={inputId}
          />
        )}
      </FormItem>
    </Container>
  );
}
